module.exports = __webpack_public_path__ + "img/b2blogo.6852eb07.png";